import {DeviceType} from 'ngx-device-detector';

import {booleanAttribute, Directive, HostBinding, inject, Input, Signal, TemplateRef, ViewContainerRef, input} from '@angular/core';

import {DeviceService} from '../services/device.service';

/**
 * <div
 * *dcDevice=""
 * ></div>
 */
@Directive({
	selector: '[dcDevice]',
	standalone: true,
})
export class DeviceConditionDirective {
	/**
	 * Sets the device condition for the directive.
	 *
	 * @input dcDevice - An object with optional properties 'mobile', 'tablet', and 'desktop'. Each property is a boolean value indicating whether the directive should be active on the respective device type. If the object is undefined, the directive is active on all device shared.
	 * If the device type matches and the corresponding property value is not false, an embedded view is created from the template reference.
	 */
	// TODO: Skipped for migration because:
	//  Accessor inputs cannot be migrated as they are too complex.
	@Input() set dcDevice(value: {mobile?: boolean; tablet?: boolean; desktop?: boolean} | undefined) {
		if (!value) {
			this.viewContainerRef.createEmbeddedView(this.templateRef);
			return;
		}
		if (this.deviceService.isMobile() && value.mobile != false) this.viewContainerRef.createEmbeddedView(this.templateRef);
		if (this.deviceService.isTablet() && value.tablet != false) this.viewContainerRef.createEmbeddedView(this.templateRef);
		if (this.deviceService.isDesktop() && value.desktop != false) this.viewContainerRef.createEmbeddedView(this.templateRef);
	}

	readonly setDeviceTypeClass = input(true);

	readonly mobileClass = input<string>(undefined);
	readonly tabletClass = input<string>(undefined);
	readonly desktopClass = input<string>(undefined);

	constructor(
		private deviceService: DeviceService = inject(DeviceService),
		private templateRef: TemplateRef<any> = inject(TemplateRef),
		private viewContainerRef: ViewContainerRef = inject(ViewContainerRef),
	) {}

	@HostBinding('class.mobile') get _mobile() {
		return this.setDeviceTypeClass() ? this.deviceService.isMobile() : '';
	}

	@HostBinding('class.tablet') get _tablet() {
		return this.setDeviceTypeClass() ? this.deviceService.isTablet() : '';
	}

	@HostBinding('class.desktop') get _desktop() {
		return this.setDeviceTypeClass() ? this.deviceService.isDesktop() : '';
	}

	@HostBinding('class') get _class() {
		const mobileClass = this.mobileClass();
		if (mobileClass && this.deviceService.isMobile()) return mobileClass;
		const tabletClass = this.tabletClass();
		if (tabletClass && this.deviceService.isTablet()) return tabletClass;
		const desktopClass = this.desktopClass();
		if (desktopClass && this.deviceService.isDesktop()) return desktopClass;
		return '';
	}
}

/* -------------------------------------------------------------------------------------------------------------- */
@Directive({
	selector: '[dc-device]',
	exportAs: 'dcDevice',
	standalone: true,
})
export class DeviceDirective {
	/* ---------------------------------------- Device Sharable Signals: ---------------------------------------- */
	public readonly deviceType: Signal<DeviceType> = this.deviceService.deviceType;
	public isMobile: Signal<boolean> = this.deviceService.isMobile;
	public isTablet: Signal<boolean> = this.deviceService.isTablet;
	public isDesktop: Signal<boolean> = this.deviceService.isDesktop;

	public landscape: Signal<boolean> = this.deviceService.landscape;
	public portrait: Signal<boolean> = this.deviceService.portrait;
	/* -------------------------------------------------------------------------------------------------------------- */
	readonly setDeviceTypeClass = input(true, {transform: booleanAttribute});

	readonly mobileClass = input<string>(undefined);
	readonly tabletClass = input<string>(undefined);
	readonly desktopClass = input<string>(undefined);

	constructor(public deviceService: DeviceService = inject(DeviceService)) {}

	@HostBinding('class.mobile') get _mobile() {
		return this.setDeviceTypeClass() ? this.isMobile() : '';
	}

	@HostBinding('class.tablet') get _tablet() {
		return this.setDeviceTypeClass() ? this.isTablet() : '';
	}

	@HostBinding('class.desktop') get _desktop() {
		return this.setDeviceTypeClass() ? this.isDesktop() : '';
	}

	@HostBinding('class') get _class() {
		const mobileClass = this.mobileClass();
		if (mobileClass && this.isMobile()) return mobileClass;
		const tabletClass = this.tabletClass();
		if (tabletClass && this.isTablet()) return tabletClass;
		const desktopClass = this.desktopClass();
		if (desktopClass && this.isDesktop()) return desktopClass;
		return '';
	}
}
